// src/components/questions/dropdownWithOther/DropdownWithOther.jsx
import React from "react";
import "./dropdownWithOther.css";

/**
 * DropdownWithOther es un componente controlado.
 * Si el valor coincide con una opción, la muestra; si no, muestra 'Otro' y un campo de texto.
 */
const DropdownWithOther = ({
  question,
  options,
  required,
  value = "",
  updateProgress
}) => {
  // Determinar si el valor actual es "Otro"
  const isOtherInitial = value !== "" && !options.includes(value);
  const [selectedOption, setSelectedOption] = React.useState(
    isOtherInitial ? "Otro" : value
  );
  const [otherAnswer, setOtherAnswer] = React.useState(
    isOtherInitial ? value : ""
  );

  const handleSelectChange = e => {
    const v = e.target.value;
    setSelectedOption(v);
    if (v !== "Otro") {
      setOtherAnswer("");
      updateProgress(v);
    }
  };

  const handleOtherChange = e => {
    setOtherAnswer(e.target.value);
  };

  const handleOtherBlur = () => {
    if (selectedOption === "Otro" && otherAnswer.trim() !== "") {
      updateProgress(otherAnswer.trim());
    }
  };

  return (
    <div className="dropdown-with-other">
      <label className="question-label">
        {question} {required && <span className="required">*</span>}
      </label>
      <select
        className="dropdown-select"
        required={required}
        value={selectedOption}
        onChange={handleSelectChange}
      >
        <option value="" disabled hidden>
          Selecciona una opción
        </option>
        {options.map((opt, idx) => (
          <option key={idx} value={opt}>
            {opt}
          </option>
        ))}
        <option value="Otro">Otro</option>
      </select>

      {selectedOption === "Otro" && (
        <input
          type="text"
          className="other-input"
          placeholder="Escribe tu respuesta"
          value={otherAnswer}
          onChange={handleOtherChange}
          onBlur={handleOtherBlur}
        />
      )}
    </div>
  );
};

export default DropdownWithOther;
